import axios from "./axios";
import store from "@/store";
import useSessionHanlder from "@/lib/useSessionHandler";
import { SentryApiException } from "@/lib/useSenterException";
import type { AxiosError, AxiosInstance } from "axios";

const sentryHandler = new SentryApiException();

/** 요청 inteceptor 처리 */
export const requestInterceptor = (instance: AxiosInstance = axios) => {
  instance.interceptors.request.use(
    function (request) {
      if (request.headers!["X-bypass"]) delete request.headers!["X-bypass"];
      else {
        const TOKEN = store.getters["auth/getSessionToken"]();
        request.headers!.authorization = TOKEN;
      }
      return request;
    },
    function (error) {
      return Promise.reject(error);
    }
  );
};

export const responseInterceptor = (instance: AxiosInstance = axios) => {
  instance.interceptors.response.use(
    function (response) {
      // 백엔드 커스텀 에러 표시 부분입니다.
      if (response.data.code === 4000) {
        store.dispatch("alert/updateErrorMsg", response.data.popup);
        store.dispatch("alert/openAlert", true);
      }
      return response;
    },
    function (error: AxiosError) {
      if (error.response) {
        sentryHandler.withReponse(error);
        const { failed } = useSessionHanlder();
        const STATUS_CODE = error.response.data.code;
        store.dispatch("alert/openAlert", STATUS_CODE);

        if (STATUS_CODE === 401) failed();
      } else if (error.request) {
        sentryHandler.withoutResponse(error, "withoutResponse");
        store.dispatch("alert/openAlert", error); // default, 네트워크를 확인해주세요!
      } else {
        sentryHandler.withoutResponse(error, "whileSetting");
        store.dispatch("alert/openAlert", error); // default, 네트워크를 확인해주세요!
      }

      return Promise.reject(error);
    }
  );
};

export default function install() {
  requestInterceptor();
  responseInterceptor();
}
